import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ZapIcon, ShieldCheckIcon, PuzzleIcon, ArrowRightIcon } from 'lucide-react';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function FeaturesSection() {
  return <section id="features" className="relative w-full bg-navy-light py-24 px-6" data-id="element-114">
      {/* Subtle top border glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-px bg-gradient-to-r from-transparent via-violet-electric/30 to-transparent" data-id="element-115" />

      <div className="max-w-5xl mx-auto" data-id="element-116">
        {/* Section label */}
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} data-id="element-117">

          <span className="text-violet-electric text-xs font-semibold tracking-[0.2em] uppercase block mb-4" data-id="element-118">
            Why Thruline
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-white tracking-tight" data-id="element-119">
            ERP that fits your business —
            <br className="hidden sm:block" data-id="element-120" />
            not the other way around
          </h2>
        </motion.div>

        {/* Feature cards */}
        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-6" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} data-id="element-121">

          {/* Card 1 */}
          <motion.div variants={itemVariants} className="group rounded-2xl border border-white/[0.06] bg-white/[0.03] p-8 backdrop-blur-sm" data-id="element-122">

            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-violet-electric/20 to-violet-electric/5 flex items-center justify-center mb-5" data-id="element-123">
              <ZapIcon className="w-5 h-5 text-violet-electric" data-id="element-124" />
            </div>
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-125">
              60-Day Delivery
            </h3>
            <p className="text-white/50 text-sm leading-relaxed" data-id="element-126">
              From kickoff to production in 60 days. We scope, build, and deploy
              your custom ERP on a fixed timeline — no surprises, no scope
              creep.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div variants={itemVariants} className="group rounded-2xl border border-white/[0.06] bg-white/[0.03] p-8 backdrop-blur-sm" data-id="element-127">

            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-magenta-hot/20 to-magenta-hot/5 flex items-center justify-center mb-5" data-id="element-128">
              <PuzzleIcon className="w-5 h-5 text-magenta-hot" data-id="element-129" />
            </div>
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-130">
              Fully Customized
            </h3>
            <p className="text-white/50 text-sm leading-relaxed" data-id="element-131">
              Every workflow, dashboard, and integration is built around how
              your team actually works. No modules you don't need, no
              workarounds.
            </p>
          </motion.div>

          {/* Card 3 */}
          <motion.div variants={itemVariants} className="group rounded-2xl border border-white/[0.06] bg-white/[0.03] p-8 backdrop-blur-sm" data-id="element-132">

            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-emerald-400/20 to-emerald-400/5 flex items-center justify-center mb-5" data-id="element-133">
              <ShieldCheckIcon className="w-5 h-5 text-emerald-400" data-id="element-134" />
            </div>
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-135">
              Fixed Pricing
            </h3>
            <p className="text-white/50 text-sm leading-relaxed" data-id="element-136">
              Know exactly what you'll pay before we write a single line of
              code. Transparent pricing across three tiers — no hidden fees,
              ever.
            </p>
          </motion.div>
        </motion.div>

        {/* See Pricing button */}
        <motion.div className="text-center mt-12" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-137">

          <Link to="/pricing" className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white text-navy font-semibold text-sm hover:bg-white/90 transition-all hover:shadow-lg hover:shadow-white/10" data-id="element-138">

            See Pricing
            <ArrowRightIcon className="w-4 h-4" data-id="element-139" />
          </Link>
        </motion.div>
      </div>
    </section>;
}